﻿import React from 'react';
import { motion } from 'framer-motion';
import { useWizard } from 'react-use-wizard';


const variants = {
    enter: (direction) => {
        return {
            x: "-15%",
            opacity: 0,
        };
    },
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1
    },
};

const WizardAnimation = ({
    children,
    previousStep: previousStepIndex,
    }) => {

    const { activeStep } = useWizard();

    React.useEffect(() => {
        previousStepIndex.current = activeStep;
    }, [activeStep, previousStepIndex]);

    return (
        <motion.div
            custom={activeStep - previousStepIndex.current}
            initial="enter"
            animate="center"
            variants={variants}
            transition={{
                x: { type: "spring", stiffness: 300, damping: 60 },
                opacity: {duration: 0.5}
            }}
        >
            {children}
        </motion.div>
    );
};

export default WizardAnimation;